import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import SendMessage from '../AppointmentsPage/SendMessageComponent';
import '../../css/chat_page.css';


export default function ViewChatPage({ selectedRoom, serviceTypes }) {
    const dispatch = useDispatch();

    const chatDetails = useSelector(state => state.chatDetails);
    const loginDetails = useSelector(state => state.loginDetails);
    var synapseRoomId = "";
    var loggedInUser = loginDetails.loggedInUser;
    var synapseEvents = chatDetails.synapseEvents;
    var matrixClient = chatDetails.matrixClient;
    if (selectedRoom) {
        synapseRoomId = selectedRoom.roomId;
    }
    const formatDate = (dateString) => {
        const options = { year: "numeric", month: "long", day: "numeric", hour: 'numeric', hour12: true }
        return new Date(dateString).toLocaleDateString(undefined, options)
    }

    const getUserDisplayName = (userId) => {
        if (selectedRoom && selectedRoom.currentState && selectedRoom.currentState.members) {
            var members = selectedRoom.currentState.members;
            if (members[userId]) {
                return members[userId].name || members[userId].displayName || userId;
            }
        }
        
        // Fallback: try to get from cached room members in localStorage
        if (synapseRoomId) {
            try {
                const allRoomMembers = JSON.parse(localStorage.getItem('roomMembers') || '{}');
                const roomData = allRoomMembers[synapseRoomId];
                if (roomData && roomData.members && roomData.members[userId]) {
                    return roomData.members[userId].name || roomData.members[userId].displayName || userId;
                }
            } catch (error) {
                console.error('Error loading cached room members:', error);
            }
        }
        
        return userId;
    }
    var objDiv = document.getElementById("innerDiv");
    if (objDiv)
        objDiv.scrollTop = objDiv.scrollHeight;

    // Filter synapseEvents to ensure only messages for current room are displayed
    const currentRoomEvents = synapseEvents && synapseEvents.filter(event => 
        event.room_id === synapseRoomId
    );


    const handleImageMessage = (imgUrl) => {
        downloadFile(imgUrl);
    }
    const downloadFile = async (imgUrl) => {
        const downloadUrl = matrixClient.mxcUrlToHttp(
            /*mxcUrl=*/ imgUrl, // the MXC URI to download/thumbnail, typically from an event or profile
            /*width=*/ undefined, // part of the thumbnail API. Use as required.
            /*height=*/ undefined, // part of the thumbnail API. Use as required.
            /*resizeMethod=*/ undefined, // part of the thumbnail API. Use as required.
            /*allowDirectLinks=*/ false, // should generally be left `false`.
            /*allowRedirects=*/ true, // implied supported with authentication
            /*useAuthentication=*/ true, // the flag we're after in this example
        );
        const img = await fetch(downloadUrl, {
            headers: {
                Authorization: `Bearer ${matrixClient.getAccessToken()}`,
            },
        });
        return img;
    }
    return (


        <Container fluid className="col-10 ">

            <div className='chat-page-room-header' >
                <p className='chat-room-header-text'>{selectedRoom && selectedRoom.name}</p>
            </div>

            <div id="chatPageOuterDiv">
                <Row>
                    <div className='chat-view-div' id="innerDiv">
                        {currentRoomEvents && currentRoomEvents.map((sEvent, index) => (
                            <>


                                {sEvent.user_id === loggedInUser.synapse_user_id &&

                                    <>
                                        <Row>
                                            <Col md="6" className='left-bubble'>
                                                <div className="sender-name">{getUserDisplayName(sEvent.sender)}</div>
                                                <div className="msgTime left">{formatDate(sEvent.origin_server_ts)}</div>
                                                <div className="sender-bubble" key={index}>
                                                    <div className="talktext">

                                                        {/* <p>{sEvent.content.body}</p> */}

                                                        {sEvent.content && sEvent.content.url === "" && <p>{sEvent.content.body}</p>}

                                                    </div>

                                                </div>
                                                <div>
                                                    {sEvent.content && sEvent.content.url !== "" && <button onClick={() => handleImageMessage(sEvent.content.url)}><p>{sEvent.content.body}</p></button>}


                                                </div>
                                            </Col>
                                            <Col></Col>
                                        </Row>
                                    </>
                                }
                                {sEvent.user_id !== loggedInUser.synapse_user_id &&

                                    <>
                                        <Row>
                                            <Col></Col>
                                            <Col md="6" className='right-bubble'>
                                                <div className="receiver-name">{getUserDisplayName(sEvent.sender)}</div>
                                                <div className="msgTime right">{formatDate(sEvent.origin_server_ts)}</div>
                                                <div className="receiver-bubble">
                                                    <div className="talktext">


                                                        {sEvent.content && sEvent.content.url === "" && <p>{sEvent.content.body}</p>}
                                                    </div>
                                                </div>
                                                <div>
                                                    {sEvent.content && sEvent.content.url !== "" && <button onClick={() => handleImageMessage(sEvent.content.url)}><p>{sEvent.content.body}</p></button>}


                                                </div>
                                            </Col>
                                        </Row>
                                    </>
                                }
                            </>
                        ))}
                    </div>
                </Row>
                <div className='send-text-div'>
                    {selectedRoom && <SendMessage
                        loggedInUser={loggedInUser}
                        synapseRoomId={synapseRoomId}
                        dispatch={dispatch}
                    />}
                </div>
            </div>

        </Container>
    );
}